export default __webpack_public_path__ + "static/flight-f724d01232d8182c1b1a75b332f98bd1.png";